import { SnowCaseImpact } from 'cmp-client-api';

export const CaseImpactOrder: Record<SnowCaseImpact, number> = {
  [SnowCaseImpact.High]: 1,
  [SnowCaseImpact.Medium]: 2,
  [SnowCaseImpact.Low]: 3,
};
